<template>
    <v-container grid-list-xs>
        <v-toolbar flat color="white">
            <v-toolbar-title>
            <h1> Reporte Inicial </h1>
            </v-toolbar-title>
            <!-- <v-btn color="green" dark  :disabled="dataVals === null">
            <download-csv
                :data="dataVals"
                :name="csvname + '.csv'"
                :labels="labels"
                :fields="fields"
            >
                <v-icon style="vertical-align: middle" left>cloud_download</v-icon>csv
            </download-csv>
            </v-btn> -->
            <v-spacer></v-spacer>
            <v-text-field
              v-model="search"
              append-icon="search"
              label="Search"
              single-line
              hide-details
            ></v-text-field>

        </v-toolbar>

        <template v-if="loading">
           <v-progress-circular
            indeterminate
            color="primary"
          ></v-progress-circular>
        </template>
        <template v-else>
          <data-table
            :headers="headers"
            :dataVals="dataVals"
            :search="search"
            :key="tableKey"
          />
        </template>
    </v-container>
</template>

<script>
import dataTable from '@/components/Tables/TableBase2'
// import JsonCSV from 'vue-json-csv'

export default {
  name: 'Reporte Inicial',
  components: {
    'data-table': dataTable
    // 'download-csv': JsonCSV
    // 'reporte-personal': TimeLineChart
  },

  data: () => ({
    backConf: {
      path: '/projects/covid/reporte_inicial/',
      path_fields: '/projects/covid/reporte_inicial_fields/',
      page: 1
    },
    operativo: null,

    tableKey: 0,

    search: '',
    headers: [
    ],
    dataVals: null,
    csvname: 'ReporteInicial',
    fields: [],
    labels: null,
    loading: true

  }),

  created () {
    this.getFields()
    this.getReportes()
  },

  methods: {

    getFields () {
      let request = {
        method: 'get',
        url: this.backConf.path_fields,
        params: {
          operativo: 41
        }
      }

      let t = this
      this.$store.dispatch('request_back', request)
        .then(function (resp) {
          let head = []
          // let labs = []
          let arr = resp.data
          // let arr2 = Object.keys(arr)
          // console.log(arr2)

          arr.forEach(element => head.push({ text: element[0], value: element[1] }))

          // arr.forEach(element => {
          //   console.log('eeee00000 :')
          //   console.log(element[0])
          //   console.log('eeee11111: ')
          //   console.log(element[1])
          // })
          // for (const obj in arr) {
          //   console.log('K0')
          //   console.log(obj[0])
          //   console.log('K1')
          //   console.log(obj[1])
          //   head.push(
          //     { text: arr[obj], value: obj }
          //   )
          //   labs[obj] = obj
          // }

          // arr.forEach(function (k, index) {
          //   console.log('K')
          //   console.log(k)
          //   head.push(
          //     { text: k, value: k }
          //   )
          //   labs[k] = k
          // })

          t.headers = head
          // t.labels = labs
          // t.fields = arr2
          console.log('header')
          // console.log(t.labels)
          console.log(t.headers)
          // console.log(t.fields)
        })
        .catch(err => console.error(err))
    },

    getReportes () {
      let request = {
        method: 'get',
        url: this.backConf.path,
        params: {
          operativo: 41
        }
      }

      let t = this
      this.$store.dispatch('request_back', request)
        .then(function (resp) {
          t.dataVals = resp.data
          t.loading = false
        })
        .catch(err => console.error(err))
    }
  }

}
</script>
